import Mutations from '../../odata/mutations';

export default { ...new Mutations('checklistItem'), ...new Mutations('checklistItems') };
